<template>
  <section>
    <div class="form-group">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <label class="inbox-label required">{{
            t("application.contact_mobile")
          }}</label>
          <MobileInput
            :fieldTitle="t('application.contact_mobile', {}, 'zh')"
            fieldname="mobile"
            fieldType="mobile"
            field-attrs="unique"
            name="mobile"
            maxlength="8"
            minlength="8"
            required
            :value="
              $store.state.form.applicantInfo.mobile
                ? $store.state.form.applicantInfo.mobile.replace('+852', '')
                : ''
            "
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <div class="row files">
            <label class="col-8 col-xs-6 col-form-label"
              ><span>{{ t("application.br") }}</span>
              <span class="text-danger">*</span></label
            >
            <div class="col-4 col-xs-6 text-right">
              <input
                :fieldTitle="t('application.br', {}, 'zh')"
                fieldname="br"
                name="br"
                type="file"
                class="form-control"
                required
                accept="image/*,.pdf"
              />
              <button class="btn btn-secondary" type="button">
                {{ t("form.upload_file") }}
              </button>
            </div>
            <div class="selected-files" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <div class="row files multiple">
            <label class="col-8 col-xs-7 col-form-label"
              ><span>{{ t("application.bank_statement") }}</span>
              <span class="text-danger">*</span></label
            >
            <div class="col-4 col-xs-5 text-right">
              <input
                :fieldTitle="t('application.bank_statement', {}, 'zh')"
                fieldname="statementSoftCopy"
                name="statement"
                type="file"
                multiple
                class="form-control"
                accept="image/*,.pdf"
                required
              />
              <button class="btn btn-secondary" type="button">
                {{ t("form.upload_file") }}
              </button>
            </div>
            <div class="selected-files" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <div class="row files multiple">
            <label class="col-9 col-sm-7 col-xs-7 col-form-label pr-0"
              ><span>{{ t("application.pos_statement") }}</span></label
            >
            <div class="col-3 col-sm-5 col-xs-5 text-right">
              <input
                :fieldTitle="t('application.pos_statement', {}, 'zh')"
                fieldname="PosStatementSoftCopy"
                name="pos_statement"
                type="file"
                multiple
                class="form-control"
                accept="image/*,.pdf"
              />
              <button class="btn btn-secondary" type="button">
                {{ t("form.upload_file") }}
              </button>
            </div>
            <div class="selected-files" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="row">
        <div class="col-md-8 col-xs-12">
          <div class="row files multiple">
            <label class="col-9 col-sm-7 col-xs-7 col-form-label pr-0"
              ><span>{{ t("application.annual_report") }}</span></label
            >
            <div class="col-3 col-sm-5 col-xs-5 text-right">
              <input
                :fieldTitle="t('application.annual_report', {}, 'zh')"
                fieldname="AnnualReportSoftCopy"
                name="annual_report"
                type="file"
                class="form-control"
                multiple
                accept="image/*,.pdf"
              />
              <button class="btn btn-secondary" type="button">
                {{ t("form.upload_file") }}
              </button>
            </div>
            <div class="selected-files" />
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div
      class="form-group"
      style="max-height: 300px; overflow-y: auto; padding: 10px 0px"
    >
      <small v-html="t('application.terms', { companyName: companyName })" />
      <small
        v-if="checkTu"
        v-html="t('application.tu_terms', { companyName: companyName })"
      />
    </div>
    <div class="form-group text-right col-xs-12">
      <label class="col-form-label"
        >{{ t("application.agree_terms") }}
        <input type="checkbox" name="terms" value="agree" required
      /></label>
    </div>
  </section>
</template>
<script>
import MobileInput from "~/components/form/MobileInput.vue";
export default {
  name: "Step4",
  components: { MobileInput },
  props: {
    checkTu: {
      type: Boolean,
      default: false,
    },
    companyName: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
